<template>
    <div>
        <Alert :alert="subscribeAlert" />
        <form
            class="form-group text-bold"
            :class="{
                busy: busy || (subscribeAlert && subscribeAlert.timeout === 0),
            }"
            style="justify-content: center"
        >
            <text-field
                autocomplete="name"
                label="Seu nome"
                v-model="fields.name"
                input-classes="input-lg"
            ></text-field>
            <text-field
                label="Seu e-mail"
                autocomplete="email"
                type="email"
                v-model="fields.email"
                input-classes="input-lg"
            ></text-field>

            <text-field
                label="Nome do seu amigo(a)"
                v-model="fields.friend_name"
                input-classes="input-lg"
            ></text-field>
            <text-field
                label="E-mail do seu amigo(a)"
                type="email"
                v-model="fields.friend_email"
                input-classes="input-lg"
            ></text-field>

            <loading-button class="btn btn-lg mt-3 btn-wide" @click="subscribe" :loading="busy">
                Enviar
            </loading-button>
        </form>
    </div>
</template>

<script>
    import Alert from '../common/Alert';
    import TextField from '@bit/chicorei.chicomponents.input.text-field';
    import LoadingButton from '../common/LoadingButton';

    export default {
        name: 'DiaDoAmigo',

        components: { Alert, TextField, LoadingButton },

        props: {},

        data() {
            return {
                subscribeAlert: null,
                busy: false,

                fields: {
                    name: this.$scope.id ? this.$scope.CUSTOMER.FIRST_NAME : null,
                    email: this.$scope.id ? this.$scope.CUSTOMER.EMAIL : null,
                    friend_name: null,
                    friend_email: null,
                },
            };
        },

        methods: {
            subscribe() {
                this.busy = true;

                this.axios.api
                    .post('/email/friendship', this.fields)
                    .then(() => {
                        this.subscribeAlert = {
                            message: 'Cupom enviado! Verifique seu e-mail!',
                            timeout: 0,
                        };
                    })
                    .catch((error) => {
                        this.subscribeAlert = {
                            message: 'Verifique os campos',
                            isError: true,
                        };
                    })
                    .then(() => (this.busy = false));
            },
        },
    };
</script>
